import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { formatCurrency } from 'js/services/Format';
import TransactionDashboardStore from 'js/stores/pages/AdminDashboardPage/TransactionDashboardStore';
import LoadingSpinner from '../../LoadingSpinner';

import DashPanel from '../../DashPanel';
import Header from '../../DashPanel/Header';
import Content from '../../DashPanel/Content';
import Pagination from '../../DashPanel/Pagination';
import Search from '../../DashPanel/Search';
import Title from '../../DashPanel/Title';
import DropMenu from '../../DashPanel/DropMenu';
import Controls from '../../DashPanel/Controls';

import TransactionStatus from '../TransactionStatus';

import Status from './Status';
import Link from './Link';
import GotoItem from './GotoItem';
import Date from './Date';
import User from './User';
import Amount from './Amount';
import Money from './Money';
import NotFound from './NotFound';
import Image from './Image';
import Info from './Info';
import Description from './Description';

@observer
export default class Dashboard extends Component {
  transactionList = TransactionDashboardStore.create({ page: parseInt(this.props['*']) || 1 });

  constructor(props) {
    super(props);
    this.transactionList.load();
  }

  componentDidUpdate() {
    this.transactionList.setPage(this.props['*']);

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('f') && urlParams.has('q')) {
      this.transactionList.setQueryParams({
        field: urlParams.get('f'),
        query: urlParams.get('q'),
      });
    }
  }

  render() {
    return (
      <DashPanel>
        <Header>
          <DropMenu />
          <Title>Transactions</Title>
          <Controls>
            <Search model={this.transactionList} options={{ total: 'Amount' }} />
            <Pagination model={this.transactionList} />
          </Controls>
        </Header>

        <Content>
          {this.transactionList.isLoading ? (
            <LoadingSpinner />
          ) : this.transactionList.transactions.length ? (
            <div>
              {this.transactionList.transactions.map(transaction => (
                <Link to={`transaction/${transaction.id}`} key={transaction.id}>
                  <Image logo_type={transaction.logo_type} logo={transaction.logo_src} />
                  <Info>
                    <Date>{transaction.created_at}</Date>
                    <User>{transaction.user}</User>
                    <Description>{transaction.human_description}</Description>
                    <Amount>
                      <Money>{formatCurrency(transaction.amount)}</Money>{' '}
                    </Amount>
                    <Status>
                      <TransactionStatus small transaction={transaction} />
                    </Status>
                  </Info>
                  <GotoItem />
                </Link>
              ))}
            </div>
          ) : (
            <NotFound>No transactions found</NotFound>
          )}
        </Content>
      </DashPanel>
    );
  }
}
